import axios from "axios";
import { store, history } from "../redux/store";
import { signinSuccess, signoutSuccess } from "../redux/actions/auth";
import appActions from "../redux/actions/app";
import { fetchAuthSession } from 'aws-amplify/auth';
import { getRouteByPathname } from "../routes/privateRoutes";

const { REACT_APP_API_URL } = process.env;

const { setAppError } = appActions

const axiosInstance = axios.create({
  baseURL: REACT_APP_API_URL,
  withCredentials: true
});

axiosInstance.interceptors.request.use(async config => {
  const authState = store.getState().auth;
  const matchedRoute = getRouteByPathname(window.location.pathname);

  if (authState.isAuthenticated) {
    const now = Math.round(Date.now() / 1000);

    if (authState.exp < now) {
      store.dispatch(signoutSuccess());
    } else {
      let idToken = authState.idToken;

      // Only force-refresh when the token expires within 60 seconds
      if (authState.exp - now < 60) {
        try {
          const session = await fetchAuthSession({ forceRefresh: true });
          store.dispatch(signinSuccess(session));
          idToken = session.tokens ? session.tokens.idToken.toString() : idToken;
        } catch {
          store.dispatch(signoutSuccess());
        }
      }

      config.headers.Authorization = `Bearer ${idToken}`;

      if (matchedRoute && matchedRoute.context) {
        config.headers["context"] = matchedRoute.context;
      }
    }
  }

  return config;
}, err => {
  return Promise.reject(err);
})

// Intercept 401 and log user out
axiosInstance.interceptors.response.use(null, error => {
  if (error) {
    if (error.response) {
      const code = error.response.status;
      const genericServerErrorMsg = `An error occurred processing your request. Please try again later.`;

      var ApiErrorMsg = error.response.data;
      //Special check for response with file methods
      if (error.response.request.responseType === 'arraybuffer'
        && error.response.data.toString() === '[object ArrayBuffer]'
      ) {
        ApiErrorMsg = Buffer.from(error.response.data).toString('utf8');
      }

      switch (code) {
        case 401:
          store.dispatch(signoutSuccess());
          break;

        case 403:
          store.dispatch(setAppError(`You are not allowed to perform this action.`));
          break;

        case 404:
          history.push('/notfound');
          break;

        case 409:
          break;

        case 503:
          history.push('/error');
          break;

        case 504:
          store.dispatch(setAppError(`Your request timed out. Please try again.`))
          break;

        case 500:
          store.dispatch(setAppError(genericServerErrorMsg))
          break;

        default:
          if (code >= 400 && code < 500) {
            store.dispatch(setAppError(ApiErrorMsg ? ApiErrorMsg : genericServerErrorMsg, 5));
          } else {
            store.dispatch(setAppError(genericServerErrorMsg));
          }
          break;
      }
    }
    else {
      history.push('/error')
    }

    store.dispatch(setAppError(null))
  }

  return Promise.reject(error);
});

export default axiosInstance;